module.exports = __webpack_public_path__ + "img/滤镜日系.24f36055.png";